import { render, staticRenderFns } from "./email-link.vue?vue&type=template&id=62de6038&functional=true&"
import script from "./email-link.vue?vue&type=script&lang=js&"
export * from "./email-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports